import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { isPlatformBrowser } from '@angular/common';
import { fadeOut } from '../animations/fade-out';
import { CookiesAcceptedService } from '../shared/services/cookies-accepted.service';

@Component({
    animations: [fadeOut],
    selector: 'app-cookies-banner',
    templateUrl: './cookies-banner.component.html',
})
export class CookiesBannerComponent implements OnInit {
    public cookiesAccepted: boolean;
    public isPlatformBrowser: boolean;
    private cookiesBannerCookie = 'shapeupspain-cookies-accepted';

    constructor(private cookieService: CookieService,
                @Inject(PLATFORM_ID) private platformId: Object,
                private cookiesAcceptedService: CookiesAcceptedService) {}

    public ngOnInit(): void {
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
        if (this.isPlatformBrowser) {
            const cookie = this.cookieService.get(this.cookiesBannerCookie);
            if (cookie == null) {
                this.cookiesAccepted = false;
            } else {
                this.cookiesAccepted = cookie !== '';
                if (this.cookiesAccepted) {
                    this.cookiesAcceptedService.acceptCookies(true);
                }
            }
        } else {
            this.cookiesAccepted = false;
        }
    }

    public acceptCookies = () => {
        this.cookiesAccepted = true;
        const aYearFromNow = new Date();
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
        this.cookieService.putObject(this.cookiesBannerCookie, true, {expires: aYearFromNow});
        this.cookiesAcceptedService.acceptCookies(true);
    }
}
